import { jsx } from "react/jsx-runtime";
import ArticleIcon from "@mui/icons-material/Article";
import { validateTidalLicense } from "../../base/index.js";
function Article(props) {
  return /* @__PURE__ */ jsx(
    ArticleIcon,
    {
      "data-testid": "Article",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Article",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Article.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Article"
};
validateTidalLicense();
export {
  Article
};
//# sourceMappingURL=Article.js.map
